import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { setCoupon } from "../checkout/checkoutSlice";
import { setAccessToken } from "../user/userSlice";

export const apiSlice = createApi({
    reducerPath: 'api',
    baseQuery: fetchBaseQuery({
        baseUrl: 'https://backend.deerparfum.com',
        // baseUrl: 'https://deer-perfume.herokuapp.com',
        // baseUrl: 'https://deer-perfum-backend.vercel.app',
        // baseUrl: 'http://localhost:5000',
    }),
    tagTypes: ["orders"],
    endpoints: (builder) => ({
        getSliders: builder.query({
            query: () => "/sliders",
            keepUnusedDataFor: 1200, // secend
        }),
        getProducts: builder.query({
            query: (page) => `/products/${page}`,
            keepUnusedDataFor: 600, // secend
        }),
        getProduct: builder.query({
            query: (productId) => `/products/sing/${productId}`
        }),
        getMostSellingProducts: builder.query({
            query: () => '/mostSelling',
            keepUnusedDataFor: 600, // secend
        }),
        getMostSellingProduct: builder.query({
            query: (productId) => `/mostSelling/${productId}`
        }),
        getProductsByNavFilter: builder.mutation({
            query: (data) => ({
                url: "/products/navfilter",
                method: "POST",
                body: data,
            })
        }),
        getProductsBySearch: builder.mutation({
            query: (data) => ({
                url: "/products/search",
                method: "POST",
                body: data,
            })
        }),
        getOrder: builder.query({
            query: (orderId) => `/orders/${orderId}`,
            // prepareHeaders: (headers, { getState }) => {
            //     console.log('accessToken', getState().user.accessToken)
            //     const token = JSON.parse(sessionStorage.getItem("accessToken")).accessToken;

            //     //     headers.set({'authorization': `Bearer jaskldjflaskjfaskdjf`})
            //     // return headers
            // },

        }),
        createToken: builder.mutation({
            query: (data) => ({
                url: "/products/login",
                method: "POST",
                body: data,
            }),
            async onQueryStarted(body, { dispatch, queryFulfilled }) {
                queryFulfilled.then(result => {
                    dispatch(setAccessToken(result.data))
                }).catch(error => {
                    if (error) {
                        dispatch(setAccessToken(''))
                    }
                })
            }
        }),
        addOrder: builder.mutation({
            query: (data) => ({
                url: "/orders",
                method: "POST",
                body: data,
            })
        }),
        addOrderOnline: builder.mutation({
            query: (data) => ({
                url: "/init",
                method: "POST",
                body: data,
            })
        }),
        // =================================
        findCoupon: builder.query({
            query: (code) => `/coupons/find/${code}`,
            // transformResponse: (response) => response.data
            async onQueryStarted(body, { dispatch, queryFulfilled }) {
                queryFulfilled.then(result => {
                    dispatch(setCoupon(result.data))
                }).catch(error => {
                    if (error) {
                        dispatch(setCoupon(''))
                    }
                })
            }
        }),
        getOrdersByUid: builder.query({
            query: (uid) => ({
                url: `/orders/user/${uid}`,
                headers: { authorization: `Bearer ${JSON.parse(sessionStorage.getItem("accessToken"))}` }
            }),
            providesTags: ["orders"]
            // prepareHeaders: (headers, { getState }) => {
            //     const token = getState().user.accessToken

            //     // If we have a token set in state, let's assume that we should be passing it.
            //     if (token) {
            //       headers.set({authorization: `Bearer ${token}`})
            //     }

            //     return headers
            //   },
            // prepareHeaders: (headers, { getState }) => {
            //     console.log('accessToken', getState().user.accessToken)
            //     const token = JSON.parse(sessionStorage.getItem("accessToken")).accessToken;

            //     //     headers.set({'authorization': `Bearer jaskldjflaskjfaskdjf`})
            //     // return headers
            // },
        }),
        deleteOrder: builder.mutation({
            query: (id) => ({
                url: `/orders/cancel/${id}`,
                method: "DELETE",
                headers: { authorization: `Bearer ${JSON.parse(sessionStorage.getItem("accessToken"))}` }
            }),
            invalidatesTags: ["orders"]
        }),


        // ======================
        loginToken: builder.mutation({
            query: (data) => ({
                url: "/products/login",
                method: "POST",
                body: data,
            }),
        }),
    }),

});

export const {
    useGetSlidersQuery,
    useGetProductsQuery,
    useGetProductQuery,
    useGetMostSellingProductsQuery,
    useGetMostSellingProductQuery,
    useGetProductsByNavFilterMutation,
    useGetOrderQuery,
    useGetProductsBySearchMutation,
    useAddOrderMutation,
    useAddOrderOnlineMutation,

    useFindCouponQuery,
    useGetOrdersByUidQuery,
    useDeleteOrderMutation,

    useLoginTokenMutation,
    useCreateTokenMutation
} = apiSlice;